'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  key: 'Group1',
  value: '37',
  date: '04/23/12'
}, {
  key: 'Group2',
  value: '12',
  date: '04/23/12'
}, {
  key: 'Group3',
  value: '46',
  date: '04/23/12'
}, {
  key: 'Group1',
  value: '32',
  date: '04/24/12'
}, {
  key: 'Group2',
  value: '19',
  date: '04/24/12'
}, {
  key: 'Group3',
  value: '42',
  date: '04/24/12'
}, {
  key: 'Group1',
  value: '45',
  date: '04/25/12'
}, {
  key: 'Group2',
  value: '16',
  date: '04/25/12'
}, {
  key: 'Group3',
  value: '44',
  date: '04/25/12'
}, {
  key: 'Group1',
  value: '24',
  date: '04/26/12'
}, {
  key: 'Group2',
  value: '52',
  date: '04/26/12'
}, {
  key: 'Group3',
  value: '64',
  date: '04/26/12'
}];